<template>
  <div class="card-tracking">
    <modal
      ref="resultsXmlModal"
      template="loading"
      title="Aguarde"
      ref-name="resultsXmlModal"
    >
      <p>Exportando resultados...</p>
    </modal>
    <card
      v-if="card.visible"
      :id="card.id"
      :key="card.id"
      :title="card.title"
      :subtitle-regular="getUpdateTime.phrase"
      :subtitle-highlight="getUpdateTime.time + ' (Período 7 dias)'"
      :buttons="card.buttons"
      :class="{ 'card-disabled': card.disabled }"
      :dropdown-options="card.dropdownOptions"
      @click="callAction"
      @btnClickAction="!card.disabled && go(card.buttons[0].action)"
    >
      <component
        :is="card.component.name"
        v-if="card.component"
        :key="card.component.key"
        :content="content"
      />
      <infotip
        v-if="card.disabled"
        :id="card.id + '-disabled'"
        :key="card.id + '-infdotip-disabled'"
        :text="
          card.disabledMessage || 'A funcionalidade está temporariamente em manutenção.'
        "
        :auto-open-on-first-days="false"
        :never-open-again-after-dismissed="false"
        :close-on-mouse-leave="true"
      />
    </card>
    <redirect-external-links ref="redirector" />
  </div>
</template>

<script>
import Card from '../Card'
import Infotip from '@/components/common/infotip/Infotip'
import GraphicData from '../Widgets/GraphicData'
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import RedirectExternalLinks from '@/components/common/RedirectExternalLinks'
import { RESULTS_RECENTS_DAYS_RANGE } from '@/enums'

export default {
  name: 'CardTracking',
  components: {
    card: Card,
    infotip: Infotip,
    'graphic-data': GraphicData,
    'redirect-external-links': RedirectExternalLinks,
  },
  data: () => ({
    daysRangeToGetResults: RESULTS_RECENTS_DAYS_RANGE,
  }),
  computed: {
    ...mapGetters([
      'getUpdateTime',
      'totalSamplesAtExecution',
      'totalReleased',
      'totalAheadSchedule',
      'totalSamplesInScreening',
      'getResultStatistics',
      'totalDelayedExamsCount',
      'profile',
      'totalSamplesReady',
      'toggle',
    ]),
    content() {
      let data = {
        graphicType: 'bar-chart',
        items: [
          {
            visible: true,
            number:
              this.toggle.sampleTraceability === true ? this.totalSamplesInScreening : 0,
            text: 'ENTREGUES AO NTO',
            traceabilityStatus: 'TRIAGEM',
            color: 'blue',
            sizeBig: true,
          },
          {
            visible: true,
            number:
              this.toggle.sampleTraceability === true ? this.totalSamplesAtExecution : 0,
            text: 'EXAMES EM EXECUÇÃO',
            traceabilityStatus: 'EM_EXECUCAO',
            color: 'yellow',
            sizeBig: true,
          },
          {
            visible: true,
            number: this.toggle.sampleTraceability === true ? this.totalReleased : 0,
            text: 'EXAMES LIBERADOS',
            traceabilityStatus: 'FINALIZADO',
            color: 'green',
            sizeBig: true,
          },
          {
            visible: true,
            number: this.toggle.sampleTraceability === true ? this.totalAheadSchedule : 0,
            text: 'EXAMES ADIANTADOS',
            traceabilityStatus: 'ADIANTADO',
            color: 'cornflower',
            sizeBig: true,
          },
          {
            visible: true,
            number:
              this.toggle.sampleTraceability === true ? this.totalDelayedExamsCount : 0,
            text: 'EXAMES EM ATRASO',
            traceabilityStatus: 'ATRASADO',
            color: 'red',
            sizeBig: true,
          },
        ],
        NTOsLeft: [],
      }
      return data
    },
    card() {
      return {
        id: 'tracking',
        visible: true,
        disabled: !this.toggle.sampleTraceability,
        title: 'Rastreabilidade - produção',
        subtitleRegular: '',
        subtitleHighlight: '',
        updateTimeVisible: true,
        template: {
          flex: 70,
          column: 3,
          row: 2,
        },
        buttons: [
          {
            text: 'ACESSAR DETALHES',
            style: 'btn-primary',
            action: '/traceability/production',
            visible: !this.toggle.covax && this.toggle.results,
          },
        ],
        dropdownOptions: [
          {
            text: 'Baixar laudos disponíveis (XML)',
            action: 'Baixar novos laudos',
            style: 'btn-link-black',
            halfWidth: true,
            id: 'btnDashboardResultsExternal',
            visible: this.toggle.examResultsPDF,
          },
          {
            text: 'Ver laudos em PDF',
            action: 'Laudos em PDF',
            style: 'btn-link-black',
            halfWidth: true,
            id: 'btnDashboardResultsExternal',
            visible: this.toggle.examResultsPDF,
            icon: '/static/images/icon-pdf-doc.svg',
          },
          {
            text: 'Ver laudos em XML',
            action: 'Resultados em XML',
            style: 'btn-link-black',
            id: 'btnDashboardResults',
            halfWidth: true,
            visible: !this.toggle.covax && this.toggle.results,
            icon: '/static/images/icon-xml-doc.svg',
          },
        ],
        component: {
          name: 'graphic-data',
          key: 2,
        },
      }
    },
  },
  methods: {
    ...mapActions([
      'exportResultByFilter',
      'selectResultList',
      'resetResultsStatistics',
      'updateResultsStatistics',
    ]),
    callAction(action) {
      switch (action) {
        case 'Resultados em XML':
          this.$router.push('results')
          break
        case 'Baixar novos laudos':
          this.exportXmlResults()
          break
        case 'Laudos em PDF':
          this.openResultsPdfPage()
          break
      }
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Dashboard Novo',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    exportXmlResults() {
      if (!this.profile.defaulter) {
        this.$refs.resultsXmlModal.open()
        this.selectResultList({
          startDate: Moment(new Date()).subtract(this.daysRangeToGetResults, 'days'),
          endDate: Moment(new Date()),
          exported: false,
          dateType: 'RD',
          integrated: null,
        })
        this.exportResultByFilter().then(downloadLink => {
          this.$refs.resultsXmlModal.close()

          if (downloadLink) {
            document.body.appendChild(downloadLink)
            downloadLink.click()

            this.resetResultsStatistics()
            this.updateResultsStatistics(this.daysRangeToGetResults)
          }
        })
      } else {
        this.$store.commit('RESULT_SET_OVERDUE', true)
      }
    },
    openResultsPdfPage() {
      this.$router.replace('/results-pdf')
    },
    go(path) {
      this.$router.push({
        path: path,
        query: {
          startDate: Moment(new Date()).clone().subtract(7, 'days').format('YYYY-MM-DD'),
          endDate: Moment(new Date()).format('YYYY-MM-DD')
        }
      })
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 1024px) {
  .card-tracking {
    margin-bottom: 40px;
  }
}
</style>
